import fetcher from 'api/fetcher';
import { mapCampaignAreasToDtoAreas } from 'utils/campaign/mappers';

import {
    type PricePerClick,
    PriceType,
    selectCampaignAreas,
    setCampaignPricePerClick,
    setCampaignPriceType,
} from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const fetchPricePerClick = (): AppThunkAction => (dispatch, getState) => {
    const state = getState();
    const { campaignId } = state.createCampaign;
    const body = {
        campaignId,
        areas: mapCampaignAreasToDtoAreas(selectCampaignAreas(state)),
    };

    return fetcher
        .put<unknown, { pricePerClickInCents: PricePerClick; priceType: PriceType }>('/api/v1/price_per_click', body)
        .then(({ pricePerClickInCents, priceType }) => {
            dispatch(setCampaignPricePerClick(pricePerClickInCents / 100));
            dispatch(setCampaignPriceType(priceType ?? PriceType.Fixed));
        });
};
